<template>
    <div class="battery-controls-mobile__container" :class="{ disabled: isDisabled }">
        <img :src="batteryImage" class="battery-controls-mobile__icon" />
        <div class="battery-level-controls-mobile" :style="{ height: batteryLevelHeight }"></div>
    </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { ngInject } from '@/vue/decorators/angular-interop';

@Component({})
export default class BatteryIconOnMobile extends Vue {
    @Prop()
    minSoc; // Battery percentage (0 to 100)
    @Prop()
    isDisabled;
    @ngInject()
    AppearanceService;

    get batteryLevelHeight() {
        const heightInRem = (13.6 * this.minSoc) / 100; // 13.6 rem is full height at 100%
        return heightInRem + 'rem';
    }

    get batteryImage() {
        return this.AppearanceService.isDarkModeActive()
            ? 'img/battery-icon-controls-mobile.svg'
            : 'img/battery-icon-controls-mobile-light.svg';
    }
}
</script>
